<template>
    <v-container fluid fill-height>
        <v-layout align-center justify-center>
            <v-flex xs12 sm8 md4>
                <v-card>
                    <v-form id="input-form" name="input-form" v-model="valid" ref="form">
                        <v-toolbar flat>
                            <v-toolbar-title>Reestablecer Contraseña</v-toolbar-title>
                        </v-toolbar>
                        <v-card-text>
                            <span>Todos los campos son requeridos.</span>
                            <v-text-field v-model='Email'
                                          name='Email'
                                          type='text'
                                          prepend-icon='person'
                                          label='Correo Electrónico'
                                          :rules="[v => !!v || 'El Correo Electrónico es requerido', v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'El Correo Electrónico debe ser válido']"></v-text-field>
                            <v-text-field v-model='Password'
                                          name='Password'
                                          type='password'
                                          prepend-icon='lock'
                                          label='Nueva Contraseña'
                                          :rules="[v => !!v || /\s/.test(v) || 'La Contraseña es requerido', v => /((?=.*\d)(?=.*[A-Z])(?=.*\W).{6,})/.test(v) || 'La contraseña debe contener al menos una letra mayúscula, una letra minúscula, un número, un carácter especial y un largo mínimo de 6 caracteres.']"></v-text-field>
                        </v-card-text>
                    </v-form>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn :disabled="!valid" v-on:click="submit"><v-icon>save</v-icon> Guardar</v-btn>
                        <v-spacer></v-spacer>
                    </v-card-actions>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>

</template>

<script>
    import script from './script'
    export default script
</script>



// WEBPACK FOOTER //
// src/components/account/resetPassword/component.vue